import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Container} from "react-bootstrap";
import HostingTableHandler from "../../components/service/HostingTableHandler";

const HostingPage = () => (
    <React.Fragment>
        <Helmet title="Hosting"/>
        <Container fluid className="p-0">
            <HostingTableHandler/>
        </Container>
    </React.Fragment>
);

export default HostingPage;
